import { Box, Skeleton } from '@mui/material';

export const TalentItemSkeleton = () => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2.5,
            background: theme => theme.palette.backgroundBar.main,
            padding: 1.5,
            paddingLeft: '18px',
            border: '1px solid rgba(255, 255, 255, 0.10)',
            borderTopLeftRadius: '16px',
            borderBottomLeftRadius: '16px',
            height: '88px',
        }}>
        <Skeleton variant="circular" width={40} height={40} />
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Skeleton variant="text" width="60%" height={20} />
            <Box sx={{ display: 'flex', gap: 1 }}>
                <Skeleton variant="text" width="30%" height={16} />
                <Skeleton variant="text" width="25%" height={16} />
            </Box>
        </Box>
    </Box>
);
